// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

// Only initialize Sentry if not in local development
const isLocalDevelopment = process.env.NODE_ENV === 'development' && !process.env.VERCEL_ENV;
const sentryEnvironment = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.VERCEL_ENV || process.env.NODE_ENV || 'development';

if (!isLocalDevelopment) {
  Sentry.init({
    dsn: "https://2184a89f7ad552fe41d878818fbf0d13@o4509790523883520.ingest.de.sentry.io/4509790547869776",

    environment: sentryEnvironment,

    // Add optional integrations for additional features
    integrations: [
      Sentry.replayIntegration(),
    ],

    // Adjust sampling based on environment
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1,

    
    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Define how likely Replay events are sampled.
    replaysSessionSampleRate: sentryEnvironment === 'production' ? 0.1 : 0.5,
    replaysOnErrorSampleRate: 1.0,

    // Debug only in preview/staging
    debug: sentryEnvironment === 'preview',

    beforeSend(event) {

      return event;
    },
  });


} else {

}

export const onRouterTransitionStart = isLocalDevelopment ? undefined : Sentry.captureRouterTransitionStart;